var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "browsing_8199448 1",
    clipPath: "url(#clip0_1456_13109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1842 54.3412H3.81578C1.71112 54.3412 0 52.6298 0 50.5255V7.47594C0 5.37128 1.71112 3.66016 3.81578 3.66016H54.1842C56.2889 3.66016 58 5.37162 58 7.47594V50.5255C58 52.6301 56.2885 54.3412 54.1842 54.3412ZM46.7222 30.8308H11.2778C10.4003 30.8308 10.4003 29.4976 11.2778 29.4976H46.7222C47.5997 29.4976 47.6001 30.8308 46.7222 30.8308ZM46.7222 24.6816H11.2778C10.3999 24.6816 10.3999 23.3484 11.2778 23.3484H46.7222C47.5997 23.3484 47.6001 24.6816 46.7222 24.6816ZM47.334 43.4927H40.0266V35.1274H47.3336C47.7017 35.1274 48.0004 35.4265 48.0004 35.7942V42.8263C48.0011 43.1936 47.702 43.4927 47.3343 43.4927H47.334ZM21.3742 36.8229C19.2237 36.8229 18.1399 39.4394 19.6604 40.9602C20.6082 41.908 22.1406 41.9077 23.0884 40.9602C24.6058 39.4428 23.5197 36.8233 21.3742 36.8233V36.8229ZM38.6934 43.4927H27.032C28.7672 41.1345 29.052 37.7548 27.1516 35.1274H38.6934V43.4927ZM15.5292 43.4927H10.6667C10.2987 43.4927 9.99994 43.1936 9.99994 42.8263V35.7939C9.99994 35.4258 10.2987 35.1271 10.6667 35.1271H15.5969C13.7219 37.7167 13.9687 41.0346 15.6353 43.387L16.4302 42.5921C14.9556 40.378 14.9348 37.2297 17.1462 35.0187C19.4823 32.6826 23.2661 32.6826 25.6022 35.0187C29.3507 38.7672 26.6741 45.2259 21.3742 45.2259C20.1508 45.2259 19.0677 44.8823 18.1708 44.3087L14.7428 47.7367C14.5131 47.9664 14.2035 48.0949 13.8786 48.0949C12.7948 48.0949 12.246 46.7763 13.0144 46.0079L15.5289 43.4934L15.5292 43.4927ZM21.3742 35.7116C18.2368 35.7116 16.6565 39.5271 18.8747 41.7456C20.2561 43.127 22.4926 43.127 23.8741 41.7456C26.0896 39.5301 24.5066 35.7116 21.3742 35.7116ZM34.7301 9.18026H30.772C29.8945 9.18026 29.8948 7.84705 30.772 7.84705H34.7301C35.6076 7.84705 35.6076 9.18026 34.7301 9.18026ZM43.2025 9.18026H39.2439C38.3661 9.18026 38.3668 7.84705 39.2439 7.84705H43.2025C44.0799 7.84705 44.0803 9.18026 43.2025 9.18026ZM51.6748 9.18026H47.7166C46.8388 9.18026 46.8391 7.84705 47.7166 7.84705H51.6748C52.5526 7.84705 52.5523 9.18026 51.6748 9.18026ZM55.5552 14.3887H2.44451V50.5255C2.44451 51.2813 3.05997 51.8961 3.81578 51.8961H54.1842C54.94 51.8961 55.5548 51.2813 55.5548 50.5255V14.3884L55.5552 14.3887Z",
    fill: "url(#paint0_linear_1456_13109)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1456_13109",
    x1: 0.000339845,
    y1: 29.0007,
    x2: 57.9997,
    y2: 29.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_13109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsing);
export default __webpack_public_path__ + "static/media/browsing.f4a9fbc10ef11b28eb05e790badf1a5f.svg";
export { ForwardRef as ReactComponent };